import React from "react";
import { Utils } from "expo-ui-kit";
import { Keyboard, StyleSheet } from "react-native";
import { KeyboardAccessoryView } from "react-native-keyboard-accessory";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";

import { Block, Button, Text, Input } from "../../components/";
import { mock, COLORS } from "../../constants/";
import { useStaturBar } from "../../utils/hooks";

const TITLES = {
  name: "Alterar nome completo",
  id: "Alterar nome de usuário",
  dob: "Alterar data de nascimento",
  phone: "Alterar número de celular",
  email: "Alterar endereço de e-mail",
  password: "Alterar senha",
  location: "Alterar idioma",
  avatar: "Alterar avatar",
};

const INFO = {
  name: "Você só pode alterar seu nome uma vez",
  id: "Opção alternativa para entrar no app Social",
  dob: "Sua data de nascimento vai personalizar seu feed",
  phone: "Um número de telefone adiciona mais segurança à sua conta",
  email:
    "Um endereço de e-mail verificado permite recuperar sua conta e encontrar seus amigos no app Social",
  password:
    "Você pode alterar sua senha a qualquer momento, é preciso ter um e-mail verificado",
  location: "Configure suas preferências de idioma com base na sua localização",
  avatar: null,
};

const EditAccount = ({ navigation, route, user = mock.USER }) => {
  const [confirmPassword, setPassword] = React.useState(null);
  const { type } = route.params;
  const value = user?.[type];

  useStaturBar();

  React.useLayoutEffect(() => {
    navigation.setOptions({ title: TITLES?.[type] });
  }, [navigation]);

  const handleSave = () => {
    Keyboard.dismiss();
    navigation.goBack();
  };

  return (
    <Block padding={24}>
      <Block>
        {INFO?.[type] && (
          <Text title center medium marginHorizontal={18} marginBottom={24}>
            {INFO?.[type]}
          </Text>
        )}
        <KeyboardAwareScrollView>
          <Input
            flex={false}
            defaultValue={value}
            style={styles.input}
            secureTextEntry={type === "password"}
          />
          {type === "password" && (
            <Input
              flex={false}
              style={styles.input}
              defaultValue={confirmPassword}
              onChangeText={(value) => setPassword(value)}
              secureTextEntry={type === "password"}
            />
          )}
        </KeyboardAwareScrollView>
      </Block>
      <KeyboardAccessoryView
        hideBorder
        style={{ backgroundColor: "transparent" }}
      >
        <Button onPress={() => handleSave()}>
          <Text title bold white center>
            Salvar alterações
          </Text>
        </Button>
      </KeyboardAccessoryView>
    </Block>
  );
};

export default EditAccount;

const styles = StyleSheet.create({
  input: {
    borderColor: Utils.rgba(COLORS.gray, 0.2),
    borderRadius: 4,
    borderWidth: 2,
    color: COLORS.gray,
    marginBottom: 16,
    padding: 14,
  },
});
